<script lang="ts">
    import { i18n, navstore } from "../store"

    import Navigation from "./Navigation.svelte"

    /*
        {
            name: "Instagram",
            link: "https://www.instagram.com/familienunternehmen_politik/",
            newtab: true,
            icon: "/media/instagram.svg",
        }
    */
    const socialnav: NavElement[] = [
        {
            name: "Twitter",
            link: "https://twitter.com/StiftungFamPol",
            newtab: true,
            icon: "/media/twitterX.svg",
        },
        {
            name: "LinkedIn",
            link: "https://www.linkedin.com/company/stiftung-familienunternehmen-und-politik",
            newtab: true,
            icon: "/media/linkedin.svg",
        },
    ]
</script>

<footer id="footer">
    <div class="container">
        <div class="row">
            <div class="col-md-4 col-sm-6">
                <h3>{$i18n("Adresse")}</h3>
                <p>
                    Stiftung Familienunternehmen und Politik<br />
                    Pariser Platz 6a<br />
                    D-10117 Berlin<br /><br />

                    {$i18n("Telefon")}: + 49 (0) 30 / 22 60 52 91 0<br />
                    {$i18n("Telefax")}: + 49 (0) 30 / 22 60 52 92 9<br /><br />

                    E-Mail: info(at)familienunternehmen-politik.de
                </p>
            </div>
            <div class="col-md-4 col-sm-6">
                <h3>{$i18n("Übersicht")}</h3>
                <div class="footernav">
                    {#if $navstore[0]}
                        <Navigation
                            data="{$navstore[0]}"
                            level="{1}"
                            depth="{1}"
                            navopen
                        />
                    {/if}
                </div>
            </div>
            <div class="col-md-4 col-sm-6">
                <h3>{$i18n("Service")}</h3>
                <div class="footernav">
                    {#if $navstore[1]}
                        <Navigation
                            data="{$navstore[1]}"
                            level="{1}"
                            depth="{1}"
                            navopen
                        />
                    {/if}
                </div>
            </div>
            <div class="col-md-4 col-sm-6">
                <h3>{$i18n("Folgen Sie uns")}</h3>
                <div class="footernav">
                    <Navigation
                        navopen
                        data="{socialnav}"
                        level="{1}"
                        depth="{1}"
                        menuclass="socialmedia"
                    />
                </div>
            </div>
        </div>
    </div>
</footer>

<style lang="less">
    @import "../css/base.less";

    #footer :global {
        max-width: 1600px;
        margin: 0 auto;
        padding: 40px 0px;
        background: @darkbg;
        color: #fff;
        font-size: 0.9rem;
        // max-width: 1640px;
        // margin: 20px auto 0px auto;
        margin-top: 20px;

        h3 {
            font-size: 1rem;
            margin-top: 0px;
            margin-bottom: 30px;
        }
        .footernav ul li .arrow {
            display: none;
        }
        ul {
            margin: 0px;
            padding: 0px;
            list-style-type: none;
            li {
                a {
                    font-size: 0.9rem;
                    display: inline-block;
                    margin-bottom: 8px;
                    color: #fff;
                    border-bottom: solid 1px transparent;
                    .transition();
                    &:hover {
                        // color: @maincolor;
                        border-color: #fff;
                    }
                }
            }
            &.socialmedia {
                .flex();
                li {
                    margin-right: 10px;
                }
                li a .text {
                    display: none;
                }
                li a .icon img {
                    width: auto;
                    height: 30px;
                }
            }
        }
    }
</style>
